export const STORE_AVAILABLE_FILTERS = 'STORE_AVAILABLE_FILTERS';
export const STORE_DROPDOWN_FILTERS = 'STORE_DROPDOWN_FILTERS';
export const UPDATE_ACTIVE_FILTERS = 'UPDATE_ACTIVE_FILTERS';
export const DESELECT_ALL_FILTERS = 'DESELECT_ALL_FILTERS';
export const STORE_GENDER_FILTER = 'STORE_GENDER_FILTER';
export const STORE_AGE_FILTER = 'STORE_AGE_FILTER';
export const STORE_PERSONAL_CATEGORY = 'STORE_PERSONAL_CATEGORY';
export const BULK_UPDATE_ACTIVE_FILTERS = 'BULK_UPDATE_ACTIVE_FILTERS';
export const ADD_PERSONAL_CATEGORY = 'ADD_PERSONAL_CATEGORY';
export const REMOVE_PERSONAL_CATEGORY = 'REMOVE_PERSONAL_CATEGORY';
export const REMOVE_FILTERS_BY_TYPE = 'REMOVE_FILTERS_BY_TYPE';
export const SET_ACTIVE_FILTER_BY_TYPE = 'SET_ACTIVE_FILTER_BY_TYPE';
export const SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS';
